export default class Tabs {
    constructor(element) {
        this.tabLinks = element.querySelectorAll('.js-tab-link')
        this.tabContents = element.querySelectorAll('.js-tab-content')

        this.tabLinks.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                this.tabLinkFunc(item, this.tabContents)
            })
        })
    }
    tabLinkFunc(item, tabContents) {
        this.link = item.dataset.tabLink
        this.tabLinks.forEach((link) => {
            link.classList.remove('active')
        })
        item.classList.add('active')
        tabContents.forEach((contentItem) => {
            if (this.link === 'show-all') {
                contentItem.classList.remove('hidden')
            } else if (!contentItem.classList.contains('hidden')) {
                contentItem.classList.add('hidden')
            }
            if (this.link === contentItem.dataset.tabTarget) {
                contentItem.classList.remove('hidden')
            }
        })
    }
}
